export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              平台优势
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              为什么数百万用户选择西瓜影视？五大核心优势告诉你答案
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {/* Feature 1 */}
            <div className="bg-background-100 rounded-xl p-6 text-center group hover:-translate-y-1 transition-transform duration-200 cursor-default">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-4">
                <i className="ri-4k-line text-primary-500 text-2xl"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">蓝光超清</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                支持4K蓝光画质，HDR10+和杜比全景声，还原影院级观影体验
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-background-100 rounded-xl p-6 text-center group hover:-translate-y-1 transition-transform duration-200 cursor-default">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-accent-100 flex items-center justify-center mb-4">
                <i className="ri-speed-line text-accent-600 text-2xl"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">流畅不缓冲</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                智能CDN加速与自适应码率，即点即播零等待
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-background-100 rounded-xl p-6 text-center group hover:-translate-y-1 transition-transform duration-200 cursor-default">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-secondary-100 flex items-center justify-center mb-4">
                <i className="ri-stack-line text-secondary-600 text-2xl"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">海量片库</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                10万+影视资源涵盖电影、剧集、综艺、动漫、纪录片
              </p>
            </div>

            {/* Feature 4 */}
            <div className="bg-background-100 rounded-xl p-6 text-center group hover:-translate-y-1 transition-transform duration-200 cursor-default">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-4">
                <i className="ri-smartphone-line text-primary-500 text-2xl"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">多端同步</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                手机、平板、电脑、电视无缝切换，观影记录云端同步
              </p>
            </div>

            {/* Feature 5 */}
            <div className="bg-background-100 rounded-xl p-6 text-center group hover:-translate-y-1 transition-transform duration-200 cursor-default">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-accent-100 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-accent-600 text-2xl"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">纯净体验</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                无弹窗广告，无强制注册，打开即看的纯粹观影享受
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}